import styled from "styled-components";
import {Button} from "@mui/material";

export const StyleButton = styled(Button)`
    && {
        padding-top: 8px;
        padding-bottom: 8px;
        display: flex;
        justify-content: space-between;
        gap: 4px;
    }

    @media (max-width: 768px) {
      font-size: 13px;
    }

    @media (max-width: 480px) {
      font-size: 12px;
      padding: 6px 12px;
    }
`;